import type { FacilityCode } from '@bond/bruce-api/common/facility'

export function facilityCodeToIcon(code: FacilityCode) {
  switch (code) {
    case 'changing':
      return 'ph-coat-hanger'
    case 'locker':
      return 'ph-lockers'
    case 'parking':
      return 'ph-letter-circle-p'
    case 'sauna':
      return 'ph-thermometer-hot'
    case 'shower':
      return 'ph-shower'
    case 'towel':
      return 'ph-towel'
  }
}
